/* 🤖 this file was generated by svg-to-ts */
export const matIconDisabledByDefault: {
  name: 'disabled-by-default';
  data: string;
} = {
  name: 'disabled-by-default',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 19H5V5h14v14zM3 3v18h18V3H3zm14 12.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/></svg>`
};
